import Vue from 'vue'
import VueRouter from 'vue-router'

Vue.use(VueRouter)

const routes = [
	{
		path: '/',
		name: 'home',
		component: () => import('@/views/home/index.vue'),
    meta: { title: '首页' },
	},
	{
		path: '/downLoad',
		name: 'downLoad',
		component: () => import('@/views/download/index.vue'),
		meta: { title: '产品下载' },
	},
	{
		path: '/theme',
		name: 'theme',
		component: () => import('@/views/theme/index.vue'),
    meta: { title: '模板主题' },
	},
	{
		path: '/wallpaper',
		name: 'wallpaper',
		component: () => import('@/views/wallpaper/index.vue'),
    meta: { title: '壁纸素材' },
	},
	{
		path: '/log',
		name: 'log',
		component: () => import('@/views/log/index.vue'),
    meta: { title: '更新日志' },
	},
  {
    path: '/details/:id',
    name: 'details',
    component: () => import('@/views/logDetails/index.vue'),
    meta: { title: '更新日志', activeMenu: "/log",hidden: true },
  }
]

const router = new VueRouter({
	mode: 'history',
	base: process.env.BASE_URL,
	routes,
})

export default router
